var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.444 2c.031 0 .062.003.092.007L9.444 2a.569.569 0 0 1 .393.16l-.06-.052a.557.557 0 0 1 .026.02l.034.032 3.334 3.272a.546.546 0 0 1 .162.386l-.005-.073.001.005.004.068v6.546c0 .903-.746 1.636-1.666 1.636H5c-.92 0-1.667-.733-1.667-1.636V3.636C3.333 2.733 4.08 2 5 2zm-.556 1.09H5a.55.55 0 0 0-.556.546v8.728a.55.55 0 0 0 .556.545h6.667a.55.55 0 0 0 .555-.545V6.363H9.443a.552.552 0 0 1-.55-.476l-.005-.069V3.09zm1.668 7.092a.55.55 0 0 1 .555.545.55.55 0 0 1-.486.541l-.07.005H6.112a.55.55 0 0 1-.555-.546.55.55 0 0 1 .485-.54l.07-.005h4.445zm0-2.182a.55.55 0 0 1 .555.545.55.55 0 0 1-.486.542l-.07.004H6.112a.55.55 0 0 1-.555-.546.55.55 0 0 1 .485-.54L6.111 8h4.445zM7.222 5.818a.55.55 0 0 1 .556.546.55.55 0 0 1-.486.54l-.07.005h-1.11a.55.55 0 0 1-.556-.545.55.55 0 0 1 .485-.542l.07-.004h1.111zM10 3.861 10 5.273l1.436-.001L10 3.861z",
    fill: "#8CAEB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaves);
export default __webpack_public_path__ + "static/media/leaves.91f831f0ec0d1f4f0407cbe6d3d173d1.svg";
export { ForwardRef as ReactComponent };